// [BD Feat] Slider JS of the Section to show Fit Result

(function () {
  function initFitResult(section) {
    const sectionId = section.dataset.sectionId;
    const carousel = section.querySelector('#fit-result-carousel-' + sectionId);

    if (!carousel || carousel.flickityInstance) return;

    const fitResult = new Flickity(carousel, {
      cellAlign: 'center',
      contain: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
      draggable: false, // disable drag/swipe
      autoPlay: 10000,
      pauseAutoPlayOnHover: false
    });

    carousel.flickityInstance = fitResult;

    const dots = section.querySelectorAll('#dot-nav-' + sectionId + ' .dot-button');

    // Activate first dot
    dots[0]?.classList.add('active');

    // Update active dot on change
    fitResult.on('change', function (index) {
      dots.forEach(btn => btn.classList.remove('active'));
      dots[index]?.classList.add('active');
    });

    // Dot click navigation
    dots.forEach((btn, index) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation(); // Prevent dot click from triggering slide change
        fitResult.select(index);
      });
    });

    // Slide to next when clicking anywhere inside the carousel (excluding dots)
    carousel.addEventListener('click', (e) => {
      if (!e.target.closest('.dot-button')) {
        fitResult.next();
      }
    });
  }

  function destroyFitResult(section) {
    const sectionId = section.dataset.sectionId;
    const carousel = section.querySelector('#fit-result-carousel-' + sectionId);

    if (carousel && carousel.flickityInstance) {
      carousel.flickityInstance.destroy();
      carousel.flickityInstance = null;
    }
  }

  function setupAllFitResultSections() {
    document.querySelectorAll('.fit-result-section').forEach(section => {
      destroyFitResult(section);
      initFitResult(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupAllFitResultSections();

    document.addEventListener('shopify:section:load', function (event) {
      const section = document.querySelector(`.fit-result-section[data-section-id="${event.detail.sectionId}"]`);
      if (section) {
        setTimeout(() => {
          destroyFitResult(section);
          initFitResult(section);
        }, 500);
      }
    });

    document.addEventListener('shopify:section:unload', function (event) {
      const section = document.querySelector(`.fit-result-section[data-section-id="${event.detail.sectionId}"]`);
      if (section) destroyFitResult(section);
    });

    document.addEventListener('shopify:theme-settings:updated', () => {
      setupAllFitResultSections();
    });
  });
})();
